import { CustomerStatus } from './customerStatusToTranslationKey';

export type CustomerFilterPresetId =
  | 'active_pipeline'
  | 'needs_follow_up'
  | 'new_leads'
  | 'try_on_stage'
  | 'won_lost'
  | 'wedding_this_month';

export const CUSTOMER_FILTER_PRESET_IDS: CustomerFilterPresetId[] = [
  'active_pipeline',
  'needs_follow_up',
  'new_leads',
  'try_on_stage',
  'won_lost',
  'wedding_this_month',
];

export function customerFilterPresetTranslationKey(id: CustomerFilterPresetId): string {
  return `customers.presets.${id}`;
}

export function getPresetStatuses(id: CustomerFilterPresetId): CustomerStatus[] {
  switch (id) {
    case 'active_pipeline':
      return ['NEW', 'VISIT', 'FOLLOW_UP', 'SECOND_FOLLOW_UP'];
    case 'needs_follow_up':
      return ['FOLLOW_UP', 'SECOND_FOLLOW_UP'];
    case 'new_leads':
      return ['NEW'];
    case 'try_on_stage':
      return ['VISIT'];
    case 'won_lost':
      return ['CLOSED', 'FAILED'];
    case 'wedding_this_month':
      return [];
  }
}

export function getCurrentMonthDropSelectValue(): string {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 3).toISOString().split('T')[0];
}

export function presetUsesWeddingMonth(id: CustomerFilterPresetId): boolean {
  return id === 'wedding_this_month';
}

function statusesEqual(a: CustomerStatus[], b: CustomerStatus[]): boolean {
  if (a.length !== b.length) {
    return false;
  }
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((status, index) => status === sortedB[index]);
}

export function detectActivePreset(
  statuses: CustomerStatus[],
  employeeIds: string[],
  selectedWeddingMonthDate: string,
): CustomerFilterPresetId | null {
  for (const id of CUSTOMER_FILTER_PRESET_IDS) {
    if (employeeIds.length > 0) {
      continue;
    }
    if (presetUsesWeddingMonth(id)) {
      const expectedMonth = getCurrentMonthDropSelectValue().substring(0, 7);
      const actualMonth = selectedWeddingMonthDate
        ? selectedWeddingMonthDate.substring(0, 7)
        : '';
      if (actualMonth === expectedMonth && statuses.length === 0) {
        return id;
      }
      continue;
    }
    if (!selectedWeddingMonthDate && statusesEqual(statuses, getPresetStatuses(id))) {
      return id;
    }
  }
  return null;
}
